import { api } from '../core/_requests'


export const getSurveyOptions = async () => {
  const result = await api.get(`user/survey/`)
  return result
}
